/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["a.btn.disabled[_ngcontent-%COMP%], a.btn[disabled][_ngcontent-%COMP%], fieldset[disabled][_ngcontent-%COMP%]   a.btn[_ngcontent-%COMP%]{pointer-events:none;cursor:default;opacity:.65;box-shadow:none}\n/*# sourceMappingURL=home.component.css.map*/"];
export { styles as styles };
